<template>
	<div class="layout">
		<div class="head">
			<div class="shareTime">分享时间：{{search.shareDate}}</div>
			<img src="../assets/imgs/duizhangdan.jpg" height="283" width="275" alt="" class="bk">
			<span id="name">尊敬的“{{search.shareUser}}”，您好！</span>
			<div id="time" v-show="search.totalBusinessDate.length>0">以下是您<span
					class="tbegin bold">{{search.totalBusinessDate[0]}}</span>至<span
					class="tend bold">{{search.totalBusinessDate[1]}}</span><br>在本店的对账单，请核实。</div>
		</div>
		<div class="total">
			<div>期初结存：<span class="right">&yen;{{balanceAmount}}</span></div>
			<div>增加应收款：<span class="right">&yen;{{totalAmount}}</span></div>
			<div>收回应收款：<span class="right">&yen;{{balanceAmount}}</span></div>
			<div>折扣合计：<span class="right">&yen;{{totalDiscount}}</span></div>
			<div>期末应收款：<span class="right">&yen;{{finalTotal}}</span></div>
			<div class="all">总欠款：<span class="right">&yen;{{finalTotal}}</span></div>
			<div class="text">单据明细请点击下载：</div>
			<a class="down" href="javascript:void(0)" @click="handleDownLoad">
				{{fullPath}}
			</a>
		</div>
		<div class="sales" v-show="itemData.length<=100">
			<ul class="bill">
				<li v-for="(item,index) in itemData" :key="index">
					<div class="date">{{item.businessDate}}</div>
					<div class="bill" v-for="(item2,index2) in item.lists" :key="index2">
						<div v-if="item2.listType == '采购单' || item2.listType == '其它付款单'">
							<div class="id">
								{{item2.listCode}}
								<span class="float-right">{{item2.listType}}</span>
							</div>
							<div>
								<span class="left">折扣：&nbsp;&yen;&nbsp;{{item2.discountAmount}}</span>
								<span class="right">增加：&nbsp;&yen;&nbsp;{{item2.amount}}</span>
							</div>
							<div>
								<span class="left">期末：&nbsp;&yen;&nbsp;{{item2.originalPrice}}</span>
								<span class="right">收回：&nbsp;&yen;&nbsp;{{item2.paymentAmount}}</span>
							</div>
						</div>
						<div v-else-if="item2.listType == '采购订单'">
							<div class="id">
								{{item2.listCode}}
								<span class="float-right">{{item2.listType}}</span>
							</div>
							<div>
								<span class="left">折扣：&nbsp;&yen;&nbsp;{{item2.discountAmount}}</span>
								<span class="right">增加：&nbsp;&yen;&nbsp;{{item2.amount}}</span>
							</div>
							<div>
								<span class="left">期末：&nbsp;&yen;&nbsp;{{item2.originalPrice}}</span>
								<span class="right">预定付款：&nbsp;&yen;&nbsp;{{item2.paymentAmount}}</span>
							</div>
						</div>
						<div v-else-if="item2.listType == '采购退货单' || item2.listType == '其它收款单'">
							<div class="id">
								{{item2.listCode}}
								<span class="float-right">{{item2.listType}}</span>
							</div>
							<div>
								<span class="left">折扣：&nbsp;&yen;&nbsp;{{item2.discountAmount}}</span>
								<span class="right">增加：&nbsp;&yen;&nbsp;{{item2.amount}}</span>
							</div>
							<div>
								<span class="left">期末：&nbsp;&yen;&nbsp;{{item2.originalPrice}}</span>
								<span class="right">退款：&nbsp;&yen;&nbsp;{{item2.paymentAmount}}</span>
							</div>
						</div>
						<div v-else-if="item2.listType == '付款单' || item2.listType == '收款单'">
							<div class="id">
								{{item2.listCode}}
								<span class="float-right">{{item2.listType}}</span>
							</div>
							<div>
								<span class="left">折扣：&nbsp;&yen;&nbsp;{{item2.discountAmount}}</span>
								<span class="right">增加：&nbsp;&yen;&nbsp;{{item2.amount}}</span>
							</div>
							<div>
								<span class="left">期末：&nbsp;&yen;&nbsp;{{item2.originalPrice}}</span>
								<span class="right">核销：&nbsp;&yen;&nbsp;{{item2.paymentAmount}}</span>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="foot">
			<div class="href" :class="itemData.length > 100 ? '' : 'flex-right'">
				<div v-if="itemData.length > 100">* 单据超100条本页面不显示明细，请下载Excel查看</div>
				<div>了解<span
						@click="this.window.location.href='http://zhj.kisdee.com/zhj_down/android/weixin.html'">不二账</span>
				</div>
			</div>
			<!-- <div class="img" v-if="showCustomPhoto || showZhjPhoto"><img :src="customPhotoPath"
					v-if="showCustomPhoto"><img :src="footImgUrl" v-if="showZhjPhoto"></div> -->
		</div>
		<!-- <div class="btn-wrapper" v-if="showPay && isWexin && needPay > 0">
			<div @click="gotoPay">立即付款</div>
		</div>
		<div class="msg" v-if="msg"><span>{{msg}}</span></div>
		<div class="dialog" v-if="showConfirmPay">
			<div class="dialog-content">
				<p v-if="payData.share_paid">分享支付：{{payData.share_paid}}</p>
				<p>待付金额：{{payData.need_pay}}</p>
				<p>本次付款：<input type="number" v-model="amount"></p>
				<p class="btn-pay"><span @click="toPay">确认付款</span></p>
			</div>
		</div> -->
	</div>
</template>

<script>
	document.getElementsByTagName("html")[0].style.fontSize = window.innerWidth / 7.5 + "px";
	window.onresize = function() {
		document.getElementsByTagName("html")[0].style.fontSize = window.innerWidth / 7.5 + "px";
	}
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	export default {
		name: 'supplierreconciliationlistshare',
		data() {
			return {
				search: {
					shareDate: '',
					shareUser: '',
					totalBusinessDate: [],
					customerId: 0
				},
				paymentTotal: 0,
				unpaidTotal: 0,
				totalDiscount: 0,
				totalAmount: 0,
				customerList: [],
				itemData: [],
				balanceAmount: 0,
				finalTotal: 0,
				fullPath:''
			}
		},
		created() {},
		watch: {
			'$route': {
				immediate: true,
				handler(param) {
					if (param.query.search && param.query.param1 && param.query.param2) {
						this.search = JSON.parse(param.query.search);
						this.initData(this.search, param.query.param1, param.query.param2);
						this.fullPath = "https://jinxiaoyd.com/#"+param.fullPath;
					}
				}
			}
		},
		methods: {
			goList(param) {
				switch (param.listType) {
					case '采购订单':
						this.$router.push({
							path: 'purchaseplanlistdetail',
							query: {
								planListId: param.id
							}
						});
						break
					case '采购单':
						this.$router.push({
							path: 'purchaselistdetail',
							query: {
								purchaseListId: param.id
							}
						});
						break
					case '其它付款单':
						this.$router.push({
							path: 'othercostlistdetail',
							query: {
								otherCostListId: param.id
							}
						});
						break
					case '其它收款单':
						this.$router.push({
							path: 'otherreceiptlistdetail',
							query: {
								otherReceiptListId: param.id
							}
						});
						break
					case '采购退货单':
						this.$router.push({
							path: 'returnlistdetail',
							query: {
								returnListId: param.id
							}
						});
						break
					case '付款单':
						this.$router.push({
							path: 'paymentlistdetail',
							query: {
								paymentListId: param.id
							}
						});
						break
					case '收款单':
						this.$router.push({
							path: 'receiptlistdetail',
							query: {
								receiptListId: param.id
							}
						});
						break
				}
			},
			handleDownLoad() {
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "是否导出对账单？",
					onOk() {
						fetch(`/api/Util/ExportSupplierReconciliationListExcel?customerId=${self.search.customerId}&startDate=${self.search.totalBusinessDate[0]}&endDate=${self.search.totalBusinessDate[1]}`, {
								method: 'GET',
								headers: new Headers({
									'Authorization': window.localStorage.getItem('token'),
									'Schema': window.localStorage.getItem('schema'),
									'WorkShop':window.localStorage.getItem('workshop')
								}),
							})
							.then(res => res.blob())
							.then(data => {
								const blobUrl = window.URL.createObjectURL(data);
								self.download(blobUrl);
							});
					},
					onCancel() {}
				});
			},
			download(blobUrl) {
				const a = document.createElement('a');
				a.download = '供应商对账单.xlsx';
				a.href = blobUrl;
				a.click();
			},
			initData(search, schame, workshop) {
				localStorage.setItem('schema', schame);
				localStorage.setItem('workshop', workshop);
				var self = this;
				request.post('/api/ReconciliationList/GetSupplierReconciliationList', search).then(function(
					result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取对账单失败"
						});
						return
					}
					self.balanceAmount = result.data.balanceAmount
					self.itemData = result.data.group
					self.paymentTotal = 0
					self.unpaidTotal = 0
					self.totalDiscount = 0
					self.totalAmount = 0
					result.data.group.forEach((item, index1) => {
						item.lists.forEach((item2, index2) => {
							if (item2.listType != '采购退货单' && item2.listType != '其它退款单') {
								self.paymentTotal += item2.paymentAmount
							}
							self.unpaidTotal += item2.unpaidAmount
							self.totalDiscount += item2.discountAmount
							self.totalAmount += item2.amount
							if (index1 == 0 && index2 == 0) {
								item2.originalPrice = formatNum(self.balanceAmount + item2
									.unpaidAmount)
							} else {
								if (index2 == 0) {
									item2.originalPrice = formatNum(result.data.group[index1 - 1]
										.lists[result.data.group[index1 - 1].lists.length - 1]
										.originalPrice + item2.unpaidAmount)
								} else {
									item2.originalPrice = formatNum(result.data.group[index1]
										.lists[index2 - 1].originalPrice + item2.unpaidAmount)
								}
							}
						});
					});
					self.paymentTotal = formatNum(self.paymentTotal)
					self.unpaidTotal = formatNum(self.unpaidTotal)
					self.totalDiscount = formatNum(self.totalDiscount)
					self.totalAmount = formatNum(self.totalAmount)
					self.finalTotal = formatNum(self.unpaidTotal + self.balanceAmount)
				}).catch(err => {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取对账单失败"
					});
				})
			}
		}
	}
</script>

<style>
	.layout {
		background-color: #edf1f7;
	}

	body,
	ul,
	li,
	img,
	span,
	div,
	p {
		border: 0;
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		line-height: 1;
	}

	span {
		display: inline-block;
	}

	ul,
	li {
		list-style-type: none;
	}

	body {
		background-color: #edf1f7;
	}

	div.head {
		color: #fff;
		height: 4.75rem;
		background-color: rgb(255, 106, 127);
	}

	img.bk {
		width: 2.75rem;
		height: 2.83rem;
		position: absolute;
		top: 0.42rem;
		right: 0.2rem;
		border-radius: 30%;
	}

	#name {
		font-size: 0.34rem;
		margin: 0.6rem 0 0.6rem 0.3rem;
	}

	#time {
		font-size: 0.24rem;
		margin: 0 0 0.24rem 0.3rem;
	}

	div.shareTime {
		font-size: 0.22rem;
		text-align: center;
		padding: 0.16rem;
	}

	.bold {
		font-weight: bold;
	}

	.tend {
		margin-bottom: 0.14rem;
	}

	.float-right {
		float: right;
	}

	.is-hidden {
		visibility: hidden;
	}

	div.total {
		width: 6.8rem;
		margin: -1.45rem auto 0.16rem;
		background-color: #fff;
		border-radius: 0.1rem;
		font-size: 0.28rem;
		color: #323232;
		padding: 0.32rem 0.4rem;
	}

	div.total .right {
		float: right;
		color: rgb(255, 106, 127);
	}

	div.total div {
		margin-bottom: 0.3rem;
	}

	div.total div.all {
		padding-top: 0.2rem;
		font-size: 0.36rem;
		margin-bottom: 0.5rem;
	}

	div.all span {
		font-size: 0.5rem;
	}

	div.total div.text {
		margin-bottom: 0.15rem;
	}

	div.total .down {
		font-size: 0.25rem;
		color: rgb(255, 106, 127);
		white-space: normal;
		word-break: break-all;
		word-wrap: break-word;
		line-height: 120%;
		margin-bottom: 0;
	}

	div.total .down-link {
		text-decoration: underline;
	}

	div.foot {
		font-size: 0.22rem;
		color: #c4c7ca;
		padding: 5px;
	}

	div.href {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 0.3rem;
		padding: 0 0.3rem;
	}

	div.href span {
		color: rgb(255, 106, 127);
	}

	div.flex-right {
		justify-content: flex-end;
	}

	div.foot div.img {
		background-color: #fff;
		padding: 0.3rem;
	}

	div.foot img {
		width: 100%;
		height: auto;
	}

	div.sales {
		font-size: 0.22rem;
		color: #b4b4b4;
	}

	ul.bill div.date {
		padding: 0.16rem 0;
	}

	ul.bill div.bill {
		background-color: #fff;
		border-radius: 0.1rem;
		border-top-left-radius: 0;
		padding: 0.16rem 0.14rem;
		margin-bottom: 0.2rem;
		position: relative;
	}

	div.bill div {
		padding: 0 0.24rem;
	}

	div.bill div.id {
		color: #323232;
		font-size: 0.26rem;
	}

	div.bill div.type {
		margin: 0.2rem 0;
	}

	div.bill span.left {
		width: 3.2rem;
	}

	div.bill img {
		width: 0.36rem;
		height: 0.36rem;
		position: absolute;
		top: 0.5rem;
		right: 0.38rem;
	}

	div.molin span,
	div.molin div {
		padding: 0.12rem 0;
	}

	div.molin {
		padding-left: 0.36rem !important;
	}

	div.sales ul.detail {
		margin-top: 0.16rem;
	}

	ul.detail li {
		border-top: 1px solid #afafaf;
		padding: 0.12rem 0;
	}

	ul.detail li div:nth-child(1) {
		color: #323232;
		margin-bottom: 0.2rem;
	}

	ul.detail span:nth-child(1) {
		width: 3.87rem;
	}

	.btn-wrapper {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 0.2rem 0.6rem;
		background-color: #fff;
	}

	.btn-wrapper div {
		width: 100%;
		height: 0.6rem;
		line-height: 0.6rem;
		background-color: rgb(255, 106, 127);
		border-radius: 4px;
		font-size: 0.28rem;
		text-align: center;
		color: #fff;
	}

	.msg {
		position: absolute;
		top: 20%;
		width: 100%;
		font-size: 0.28rem;
		color: #fff;
		text-align: center;
	}

	.msg span {
		background-color: rgba(0, 0, 0, 0.5);
		border-radius: 4px;
		padding: 0.2rem 1.2rem;
		text-align: center;
	}

	.dialog {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		background-color: rgba(0, 0, 0, 0.5);
	}

	.dialog-content {
		background-color: #fff;
		border-radius: 5px;
		padding: 0.3rem 0.5rem;
		font-size: 0.3rem;
	}

	.dialog-content input {
		padding: 5px 10px;
		width: 2rem;
	}

	.dialog-content p {
		height: 0.8rem;
		line-height: 0.8rem;
	}

	.show-link-content {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.show-link-content img {
		border-radius: 100%;
		border: 16px solid #e2fdff;
	}

	.show-link-content img,
	p {
		margin-bottom: 20px;
	}

	.show-link-content .copy-link {
		color: #fff;
		width: 100%;
		padding: 10px 0;
		background-color: rgb(255, 106, 127);
		border-radius: 6px;
		text-align: center;
		margin-top: 20px;
	}

	.show-link-content input {
		width: 100%;
		border: none;
		background: #f5f5f5;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.btn-pay {
		text-align: center;
		margin-top: 0.3rem;
	}

	.btn-pay span {
		display: inline-block;
		width: 2rem;
		border-radius: 4px;
		background-color: rgb(255, 106, 127);
		padding: 7px 10px;
		color: #fff;
	}
</style>